import Pigeonline from './lib/Pigeonline';

export default {
  install(app, options) {
    app.config.globalProperties.$pigeonline = new Pigeonline(options, app);
  },
};
